import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { useAuth } from './useAuth';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main className="auth-loading" aria-label="Caricamento sessione">
        <span className="loader-mark" />
        <p>Prepariamo il tuo workspace</p>
      </main>
    );
  }

  if (!user) {
    return <Navigate to="/accesso" replace state={{ from: location.pathname }} />;
  }

  return children;
}
